export interface DashboardResultsContextProps {
  isDateModalOpen: boolean;
  setDateModalOpen: (open: boolean) => void;
  currentPeriod: StatsPeriods;
  setCurrentPeriod: React.Dispatch<React.SetStateAction<StatsPeriods>>;
  currentDates: Date[];
  setCurrentDates: React.Dispatch<React.SetStateAction<Date[]>>;
}

export enum StatsPeriods {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Custom = 'custom',
}
